import axios from 'axios';

const baseURL = process.env.REACT_APP_BASE_URL;

const clearSessionAndRedirect = () => {
    localStorage.clear();
    window.location.href = '/';
};

export const getToken = async () => {
    if (localStorage.getItem('token') == null || localStorage.getItem('refreshToken') == null) {
        clearSessionAndRedirect();
        return;
    }
    const token = localStorage.getItem('token');
    const refreshToken = localStorage.getItem('refreshToken');
    let params = {
        "jwttoken": token,
        "refreshToken": refreshToken
    }
    return axios.post(`${baseURL}/refreshAuth`, params).then((response) => {
        localStorage.setItem('token', response.data.token);
        localStorage.setItem('refreshToken', response.data.refreshToken);
        return response.data.token;
    }).catch((error) => {
        // Any refresh failure (401, 500, network error) — wipe session and redirect.
        clearSessionAndRedirect();
        throw error;
    });
}